import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE, withCredentials: true });

export function fileUrl(path) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
}

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Si è verificato un errore";
  if (typeof d === "string") return d;
  if (d.message) return d.message;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return JSON.stringify(d);
}

export default api;
